module.exports = __webpack_public_path__ + "img/netProfitPedestal.9a02156b.png";